import { getInstance } from '../../../lib/axios';
import constants from '../../../constants';

export async function getAllPersonalTraining(id) {
  try {
    const url = `${constants.endpoints.TRAINING_SESSION}/personalTraining/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch all personal training failed', error.message);
    throw error;
  }
}

export async function getPersonalTrainingCustomTrainingWorkouts(trainingId, userId) {
  try {
    const url = `${constants.endpoints.TRAINING_SESSION}/workouts/${trainingId}/user/${userId}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch all custom workouts connected to personal training failed', error.message);
    throw error;
  }
}

export async function createWorkoutDetails(data) {
  try {
    const response = await getInstance().post(constants.endpoints.TRAINING_SESSION, data);
    return response.data;
  } catch (error) {
    console.error('Create workout details failed', error.message);
    throw error;
  }
}